import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const menuDataSlice = createSlice({
    name: "menuData",
    initialState,
    reducers: {},
});

export default menuDataSlice.reducer;
